/**
 * Extract numeric facilityId from a facility URL path segment.
 * e.g., "great-value-storage-12345" → "12345"
 */
export function parseFacilityId(facilityPath) {
	if (!facilityPath) return null;
	let i = facilityPath.length - 1;
	while (i >= 0 && facilityPath[i] >= '0' && facilityPath[i] <= '9') {
		i--;
	}
	const digits = facilityPath.slice(i + 1);
	return digits.length > 0 ? digits : null;
}

/**
 * Extract PSP keyword from a storage-types URL slug.
 * Handles two patterns:
 *   "{keyword}-self-storage" → keyword  (e.g., "vehicle-self-storage" → "vehicle")
 *   "self-storage-{keyword}" → keyword  (e.g., "self-storage-for-boats" → "for-boats")
 */
export function parsePSPKeyword(pspSlug) {
	if (!pspSlug) return null;
	if (pspSlug.endsWith('-self-storage')) {
		return pspSlug.replace(/-self-storage$/, '');
	}
	if (pspSlug.startsWith('self-storage-')) {
		return pspSlug.replace(/^self-storage-/, '');
	}
	return pspSlug;
}

/**
 * Derive facilityId/keyword/moveInStatus from raw route params the same
 * way for both the client (EnhancedRoute) and SSR (matchStaticRoutes), so
 * the two can't silently drift apart the way confirmSlug-based
 * moveInStatus parsing once did (SF-22302).
 *
 * @param {object} rawParams - params straight from useParams()/matchPath
 * @param {{moveInStatus?: string}} [routeConfig] - static config from the
 *   matched route (app/routes.js), not derived from the URL
 */
export function enrichRouteParams(rawParams, routeConfig = {}) {
	const enriched = { ...rawParams };
	if (rawParams.facilityPath) {
		enriched.facilityId = parseFacilityId(rawParams.facilityPath);
	}
	if (rawParams.citySlug) {
		const cityFacilityId = parseFacilityId(rawParams.citySlug);
		if (cityFacilityId) {
			enriched.facilityId = cityFacilityId;
		}
	}
	if (rawParams.pspSlug) {
		enriched.keyword = parsePSPKeyword(rawParams.pspSlug);
	}
	if (routeConfig.moveInStatus) {
		enriched.moveInStatus = routeConfig.moveInStatus;
	}
	return enriched;
}
